module.exports = __webpack_public_path__ + "static/media/S7.6a8bd3b4.png";